@for (item of items; track trackBy($index, item)) {
  <div
    class="floori-chip floori-d-inline-flex floori-align-items-center floori-pointer"
    [class.selected]="selectedMap[item.value]"
    [flooriSkeletonLoader]="loading"
    (click)="onChipClick(item)">
    @if (item.icon) {
      <floori-icon
        [name]="item.icon | resolveImg"
      class="floori-icon"></floori-icon>
    }
    <p class="floori-caption floori-semi-regular floori-pointer">
      {{ item.translation ? (item.translation | flTranslate) : item.label }}
    </p>
    @if (showClear) {
      <floori-icon name="fl_close"></floori-icon>
    }
  </div>
}
